<template lang="pug">
form.feature-update(@submit.prevent="updateAssign")
  .form-field
    label
      .form-field-select
        SelectInput(
          header="Assign To",
          :options="users",
          label="fullName",
          :disabled="feature.isReadOnly",
          :empty="{ fullName: 'Unassigned', _id: null }",
          v-model="updateAssignForm.assignedTo._id",
          @change="setAssign"
        )
  .status-details(v-if="showUpdateAssign")
    .form-field
      textarea(v-model="updateAssignForm.comment", placeholder="Comment")
    .form-field
      SubmitButton(label="Submit", :formState="assignState")
      button.button.button-none(type="button", @click="reset") Cancel

      //-button.button.primary-button(type="submit") Submit
</template>

<script>

import { mapState } from 'vuex'
import SelectInput from '@/components/helpers/SelectInput'

export default {
  name: 'FeatureAssign',
  components: {
    SelectInput
  },
  props: {
  },
  beforeMount () {
    //console.log(this.feature)
    if (this.feature.assignedTo) {
      this.updateAssignForm.assignedTo = this.feature.assignedTo
    }
  },
  data () {
    return {
      showUpdateAssign: false,
      assignState: 'initial',
      updateAssignForm: {
        assignedTo: {
          _id: null
        },
        comment: ''
      },
    }
  },
  computed: {
    ...mapState({
      feature: state => state.features.selected,
      users: state => state.users
    })
  },
  methods: {
    reset () {
      this.showUpdateAssign = false
      //console.log(this.feature)
      if (this.feature.assignedTo) {
        this.updateAssignForm.assignedTo = this.feature.assignedTo
      } else {
        this.updateAssignForm.assignedTo = {
          _id: null,
        }
      }
      this.updateAssignForm.comment = ''
    },
    setAssign () {
      this.showUpdateAssign = true
    },
    updateAssign () {
      let update = {
        slug: this.feature.slug,
        assign: {
          assignedTo: this.updateAssignForm.assignedTo._id,
          comment: this.updateAssignForm.comment
        }
      }

      let dispatchEvent = 'features/updateUnassign'
      if (update.assign.assignedTo) {
        dispatchEvent = 'features/updateAssign'
      }
      this.statusState = 'pending'
      this.$store.dispatch(dispatchEvent, update)
        .then(result => {
          this.assignState = 'initial'
          this.showUpdateAssign = false
          this.updateAssignForm.comment = ''
          this.$store.dispatch('activities/addAssignUpdate', result)
        }, () => {
          this.statusState = 'error'
        })

    }
  }
}
</script>

<style scoped lang="stylus">
.feature-update
  margin-bottom $spacing-3
  .form-field
    margin-bottom $spacing


</style>
